import { createApp } from 'vue'
import Notifications from '@kyvg/vue3-notification';
// import vuelidate from 'vuelidate';

import App from './App.vue';
import router from './router/index';
import store from './store/index';
import loader from './components/Loader.vue';


import './permission';


const app = createApp(App);
app.config.globalProperties.$filters = {
   // This application is used to check the specified policy is there are not.
   policyChecker(rootElement) {
    try {
      let policy = store.state.user.policy;
        // to check the policy string is empty or not
        if (policy) {
            // to check the policy is json and that json have length greaterthan 0
            if (this.isJson(policy) && Object.keys(policy).length !== 0) {
                // To get the number of slash count
                let count = this.getSlashCount(rootElement);
                // To check the slash count is 0
                if (count == 0) {
                    // To check the policy have specified key
                    if (policy.hasOwnProperty(rootElement)) {
                        // To check the key have value or not
                        if (policy[rootElement]) {
                            return policy[rootElement];
                        }
                        else {
                            return "0";
                        }
                    }
                    else {
                        return "0";
                    }
                }
                // To check the slash count is 1
                else if (count == 1) {
                    let mystring = rootElement;
                    // Split the string with '/' and store that values in array
                    let splittable = mystring.split('/');
                    let string1 = splittable[0];
                    let string2 = splittable[1];
                    // To check the array of keys are available in policy or not
                    if (policy.hasOwnProperty(string1) && policy[string1].hasOwnProperty(string2)) {
                        // To check the key have value or not
                        if (policy[string1][string2]) {
                            return policy[string1][string2];
                        }
                        else {
                            return "0";
                        }
                    }
                    else {
                        return "0";
                    }
                }
                else {
                    throw new Error('feature is not supported');
                }
            }
            else {
                return "0";
            }
        }
        else {
            return "0";
        }
    } catch (ex) {
        throw ex;
    }

},
  // This function is used to check the number of slash occured in a string
  getSlashCount(str) {
      let count = 0;
      for (let i = 0; i < str.length; i++) {
          if (str.charAt(i) == "/") {
              count += 1;
          }
      }
      return count;
  },
  isJson(item) {
      item = typeof item !== "string" ? JSON.stringify(item) : item;
      try {
          item = JSON.parse(item);
      } catch (e) {
          return false;
      }

      if (typeof item === "object" && item !== null) {
          return true;
      }

      return false;
  },
  dateformat(value)
  {
    if (!value) return '';
  
    // const curDate = new Date(value);
    const newVal = `${new Date(value).toLocaleDateString('en-IN', {
      year: 'numeric', month: 'short', day: 'numeric', timeZone: 'Asia/Kolkata',
    })
    } ${new Date(value).toLocaleTimeString('en-IN', { timeZone: 'Asia/Kolkata' })}`;
    return newVal;
  },
  dateformat1(value)
  {
    if (!value) return '';
  const newVal = `${new Date(value).toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' })}`;
  if(newVal=="Invalid Date"){
    return "N/A"
}
  return newVal;
  },
  priceformat(amount)
  {
    if (!amount) {
      return '';
    }
    
    if (amount == 0) { return '₹0.00'; }
    return amount.toLocaleString('en-IN', {
      maximumFractionDigits: 2,
      style: 'currency',
      currency: 'INR',
    });
  },
  numberFormat(value)
  {
    if (!value) return '';
    return value.toLocaleString('en-IN');
  },
  isCheckTransactionDateExceed(txnDt) {
		const currentDate = new Date();
		const transactionDate = new Date(txnDt);
		const daysSinceTxnDate = Math.floor((currentDate - transactionDate) / (1000 * 60 * 60 * 24));
		return daysSinceTxnDate > 90;
	},
    // Helper method to copy text to clipboard and update tooltip
    async copyText(elementId, tooltipId, replace = null) {
        let copyText = document.getElementById(elementId).innerText;
        
        const tooltipElement = document.getElementById(tooltipId);

        try {
        if(replace != null){
            copyText = copyText.replace(replace,"");
        }
        // Try using the modern clipboard API
        await navigator.clipboard.writeText(copyText);
        tooltipElement.setAttribute("data-tooltip", "Copied");
        
        // Reset tooltip after a delay
        setTimeout(() => {
            tooltipElement.setAttribute("data-tooltip", "Copy");
        }, 5000);
        } catch (err) {
        }
    },
}
app.directive("disable-leading-space",{
  update(el) {
              // using regex to only remove spaces at the beginning
              el.value = el.value.replace(/^\s+/g, ''); // or you can use your own preferred way to remove leading spaces
              el.dispatchEvent(new Event('input'));
          },
})

app.config.productionTip = false;
// Vue.use(Notifications);
// Vue.use(vuelidate);
app.component('loader', loader);
// Vue.filter('dateformat', (value) => {
//   if (!value) return '';
  
//   // const curDate = new Date(value);
//   const newVal = `${new Date(value).toLocaleDateString('en-IN', {
//     year: 'numeric', month: 'short', day: 'numeric', timeZone: 'Asia/Kolkata',
//   })
//   } ${new Date(value).toLocaleTimeString('en-IN', { timeZone: 'Asia/Kolkata' })}`;
//   return newVal;
// });
// Vue.filter('dateformat1', (value) => {
//   if (!value) return '';
//   const newVal = `${new Date(value).toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' })}`;
//   if(newVal=="Invalid Date"){
//     return "N/A"
// }
//   return newVal;
// });

// Vue.filter('priceformat', (amount) => {
  
//   //amount = Number(amount);
//   if (!amount) {
//     return '';
//   }
  
//   if (amount == 0) { return '₹0.00'; }
//   return amount.toLocaleString('en-IN', {
//     maximumFractionDigits: 2,
//     style: 'currency',
//     currency: 'INR',
//   });

// });
// Vue.filter('numberFormat', (value) => {
//   if (!value) return '';
//   return value.toLocaleString('en-IN');
// });
// Vue.directive('disable-leading-space', { // you can rename it to your liking
//   update(el) {
//     // using regex to only remove spaces at the beginning
//     el.value = el.value.replace(/^\s+/g, ''); // or you can use your own preferred way to remove leading spaces
//     el.dispatchEvent(new Event('input'));
//   },
// });
app.use(store);
app.use(router);
app.use(Notifications);
app.mount('#app');
